import React, { useState } from 'react'
import { Input } from './../Form/Input'
import { Checkbox } from './../Form/Checkbox'
import { ButtonDelete } from './../Buttons/ButtonDelete'
import './types'
import {
  convertMonetaryDollarStringToCentValue,
  convertCentValueToMonetaryString,
} from './../../Utils/Formatters'
import { number } from '../../Utils/Validators/formValidation'

/**
 * @param {MetricRowProps} props
 */
const MetricRow = props => {
  const {
    name,
    targetConversionRate,
    targetCostPerMetric,
    onTargetCostPerMetricChange,
    onTargetConversionRateChange,
    onNameChange,
  } = props
  const [metricName, setMetricName] = useState(name)
  const [inputTargetConversionRate, setInputTargetConversionRate] = useState(
    convertConversionRateValueToPercentString(targetConversionRate),
  )
  const [inputTargetCostPerMetric, setInputTargetCostPerMetric] = useState(
    convertCentValueToMonetaryString(targetCostPerMetric),
  )

  return (
    <div>
      <div className="metrics-row">
        <div className="section-column">
          <Input
            label="Metric's Name"
            placeholder="Metric's Name"
            value={metricName}
            onChange={e => setMetricName(e.target.value)}
            onBlur={e => {
              onNameChange(e.target.value)
            }}
          />
        </div>
        <div className="section-column" />
        <div className="section-column">
          <Input
            type="number"
            label="Target Conversion Rate"
            name="targetConversionRate"
            placeholder="Estimate"
            value={inputTargetConversionRate}
            className="input-with-icon input-with-icon_percent"
            onChange={e => setInputTargetConversionRate(e.target.value)}
            onBlur={e => {
              var newRate = convertConversionRatePercentStringToValue(
                e.target.value,
              )
              if (newRate === null) setInputTargetConversionRate('')
              onTargetConversionRateChange(newRate)
            }}
            validator={[number]}
          />
        </div>
        <div className="section-column">
          <Input
            type="number"
            label="Target Cost Per Metric"
            name="targetCostPerMetric"
            placeholder="Estimate"
            value={inputTargetCostPerMetric}
            onChange={e => setInputTargetCostPerMetric(e.target.value)}
            onBlur={e => {
              const newVal = convertMonetaryDollarStringToCentValue(
                e.target.value,
              )
              if (newVal === null) setInputTargetCostPerMetric('')
              onTargetCostPerMetricChange(newVal)
            }}
            validator={[number]}
          />
        </div>
        <div>
          <Checkbox
            label="Primary Metric"
            checked={props.isPrimary}
            onClick={props.onPrimaryMetricToggle}
          />
        </div>
        <div className="section-column">
          <ButtonDelete onClickHandler={() => props.onDelete()} />
        </div>
      </div>
    </div>
  )
}

export default MetricRow

/**
 * Convert the visual percent value to a numeric decimal value.
 * @param {string} str
 * @returns {number|null}
 */
function convertConversionRatePercentStringToValue(str) {
  var val = Number(str)
  if (isNaN(val)) return null
  return val / 100
}

/**
 * Convert the real conversion rate value to a string percent value.
 * @param {number} val
 * @returns {string}
 */
function convertConversionRateValueToPercentString(val) {
  if (val == null || val == undefined) return ''
  return val * 100 + ''
}



// WEBPACK FOOTER //
// ./src/Components/MetricsEdit/MetricRow.js